/**
 *  获取最近的指定祖先元素（包括自身）
 *  例如：
 *  const target = e.target
    if (
      getClosestAncestor(target, 'dynamics-avatar-wrap') ||
      getClosestAncestor(target, 'dynamics-info-name')
    ) {
      return
    }
 */
function getClosestAncestor(el, className) {
  if (!el || !className) return null
  let p = el
  while (p) {
    if (p.classList.contains(className)) {
      return p
    }
    p = p.parentElement
  }
  return null
}

export { getClosestAncestor }



// WEBPACK FOOTER //
// ./src/public-resource/libs/utils/domUtil.js